import { combineReducers } from 'redux';

import entities from './taskEntities/reducers';
import tasksToProjectsRelation from './tasksToProjectsRelation/reducers';
import loadingState from './loadingState/reducers';

export default combineReducers({
  entities,
  loadingState,
  tasksToProjectsRelation,
});
